import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../../common/types';
import { lyricPanelMessages } from './lyricPanelMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the lyric panel; each part uses its own slice of it */
import styles from './LyricLinePanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface LyricSearchBoxProps {
  query: string;
  hitCount: number;
  onQuery: (query: string) => void;
  inputRef: React.RefObject<HTMLInputElement | null>;
}

/** The search of the panel (design b3). Esc clears it; the picked line stays. */
const LyricSearchBoxComponent: React.FC<LyricSearchBoxProps> = ({ query, hitCount, onQuery, inputRef }) => {
  const intl = useIntl();
  const label = intl.formatMessage(lyricPanelMessages.searchLabel);
  const active = query.trim() !== '';
  return (
    <div className={active ? `${styles.search} ${styles.searchOn}` : styles.search}>
      <span className={styles.searchIcon} aria-hidden="true" />
      <input
        ref={inputRef}
        type="search"
        className={styles.searchInput}
        placeholder={label}
        aria-label={label}
        value={query}
        onChange={(event) => onQuery(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            onQuery('');
          }
        }}
      />
      {active && (
        <button type="button" className={styles.searchClear} onClick={() => onQuery('')}>
          {intl.formatMessage(lyricPanelMessages.searchCount, { count: hitCount })} &middot;{' '}
          {intl.formatMessage(lyricPanelMessages.clear)}
        </button>
      )}
    </div>
  );
};

export const LyricSearchBox = TypedMemo(LyricSearchBoxComponent);
